import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { CONTACT } from "../../data";

const LINKS = [
  { label: "Products", href: "#products" },
  { label: "Ethos", href: "#ethos" },
  { label: "Legacy", href: "#legacy" },
  { label: "Enquire", href: "#contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <motion.header
        initial={{ y: -80 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
          scrolled ? "bg-void/90 backdrop-blur-xl border-white/10" : "border-transparent"
        }`}
        data-testid="site-nav"
      >
        <div className="mx-auto max-w-[1600px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
          <a href="#top" data-testid="nav-logo" className="flex items-center group">
            <img src="/logo-light.png" alt="Scientific Industries" className="h-8 md:h-10 w-auto" />
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="font-mono text-xs uppercase tracking-[0.2em] text-plasma/70 hover:text-forge transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <a
            href="#contact"
            data-testid="nav-cta"
            className="hidden md:inline-flex font-mono text-xs uppercase tracking-[0.2em] bg-plasma text-void px-5 py-3 hover:bg-forge transition-colors"
          >
            Get a Quote
          </a>

          <button
            className="md:hidden text-plasma"
            onClick={() => setOpen(true)}
            data-testid="nav-menu-open"
            aria-label="Open menu"
          >
            <Menu size={26} />
          </button>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-void md:hidden flex flex-col"
            data-testid="mobile-menu"
          >
            <div className="h-16 px-5 flex items-center justify-between border-b border-white/10">
              <span className="font-head font-extrabold uppercase text-lg">Menu</span>
              <button onClick={() => setOpen(false)} data-testid="nav-menu-close" aria-label="Close menu">
                <X size={26} />
              </button>
            </div>
            <div className="flex-1 flex flex-col justify-center px-6 gap-2">
              {LINKS.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-link-${l.label.toLowerCase()}`}
                  initial={{ x: -30, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 0.1 + i * 0.07 }}
                  className="font-head font-bold uppercase text-5xl tracking-tight text-plasma hover:text-forge transition-colors"
                >
                  {l.label}
                </motion.a>
              ))}
            </div>
            <div className="p-6 border-t border-white/10 font-mono text-xs text-plasma/60">
              {CONTACT.phone}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
